import { getState } from "core-web/state";

export default () => {
    let returnValue = "";
    if (typeof window !== "undefined") {
        returnValue = window.location.pathname;
    } else {
        returnValue = getState("application").currentPathname;
    }
    return returnValue;
};
